/* eslint-disable */
import React from 'react';
import ReactModal from 'react-modal';
import { RegularButton } from 'pg-ui-library';
import closeSvg from 'src/assets/close.svg';
import { Header, FormTitle, CloseIcon, ContentContainer, BottomContainer } from './filtersStyles';

import {
  ModalContainer,
  Subtitle,
  OptionsContainer,
  DownloadCard,
  IconContainer,
  TextContainer,
  Title,
  Description,
} from './downloadModalStyles';

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onDownload: (type: 'csv' | 'excel' | 'pdf') => void;
  loading?: boolean;
}

const DownloadInvoiceModal: React.FC<Props> = ({ isOpen, setIsOpen, onDownload, loading }) => {
  const handleClose = () => setIsOpen(false);

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={handleClose}
      ariaHideApp={false}
      style={{
        overlay: { backgroundColor: 'rgba(0, 0, 0, 0.6)' },
        content: {
          borderRadius: '20px',
          backgroundColor: '#F3F4F8',
          margin: 'auto',
          width: '400px',
          height: '450px',
          padding: '20px',
        },
      }}
    >
      <ModalContainer>
        <Header>
          <FormTitle>Download Invoice</FormTitle>
          <CloseIcon src={closeSvg} onClick={handleClose} />
        </Header>

        <Subtitle>Choose your preferred format</Subtitle>

        <OptionsContainer>
          <DownloadCard disabled={loading} onClick={() => onDownload('excel')}>
            <IconContainer>📊</IconContainer>
            <TextContainer>
              <Title>Excel</Title>
              <Description>Export as .xlsx spreadsheet</Description>
            </TextContainer>
          </DownloadCard>

          <DownloadCard disabled={loading} onClick={() => onDownload('csv')}>
            <IconContainer>📄</IconContainer>
            <TextContainer>
              <Title>CSV</Title>
              <Description>Lightweight data format</Description>
            </TextContainer>
          </DownloadCard>

          <DownloadCard disabled={loading} onClick={() => onDownload('pdf')}>
            <IconContainer>🧾</IconContainer>
            <TextContainer>
              <Title>PDF</Title>
              <Description>Printable document format</Description>
            </TextContainer>
          </DownloadCard>
        </OptionsContainer>
      </ModalContainer>
    </ReactModal>
  );
};

export default DownloadInvoiceModal;
